export default "__VITE_ASSET__$Yg9wXDN__"